'use client';

import { c as _c } from "react/compiler-runtime";
import { Suspense, useCallback, useState } from 'react';
import { Skeleton } from '@sola/ark-core/atoms/skeleton/skeleton.tsx';
import { ArticleTypesEnum } from '@sola/contentful-model/lib/taxonomy-values.ts';
import { ArticleFilter } from './article-filter.tsx';
import { ArticleList } from './article-list.tsx';
const ArticleFilterSkeleton = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="body-md md:align-center"><Skeleton height={20} width={120} /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="ArticleFilter"><div className="ArticleFilter__container flex flex-col md:flex-row md:justify-between md:align-center gap-comfy-lg">{t0}<div className="flex align-end md:justify-end md:align-center gap-comfy-sm"><Skeleton height={40} width={140} borderRadius="0.5rem" /><Skeleton height={40} width={80} borderRadius="0.5rem" /></div></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
type ArticleControlsProps = {
  seoLevel?: number;
  articleType?: ArticleTypesEnum;
  topic?: string;
  country?: string;
  theme?: string;
  limit?: number;
};
export const ArticleControls = t0 => {
  const $ = _c(15);
  const {
    seoLevel,
    articleType,
    topic,
    country,
    theme,
    limit
  } = t0;
  const [articleCount, setArticleCount] = useState(undefined);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = t2 => {
      const {
        totalCount
      } = t2;
      setArticleCount(totalCount);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const onArticleLoad = t1;
  const articleFilterCount = topic || country || theme ? articleCount : undefined;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ArticleFilterSkeleton />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== articleFilterCount || $[3] !== limit) {
    t3 = <Suspense fallback={t2}><ArticleFilter articleCount={articleFilterCount} limit={limit} /></Suspense>;
    $[2] = articleFilterCount;
    $[3] = limit;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== articleType || $[6] !== country || $[7] !== limit || $[8] !== seoLevel || $[9] !== theme || $[10] !== topic) {
    t4 = <ArticleList seoLevel={seoLevel} articleType={articleType} topic={topic} country={country} theme={theme} limit={limit} onArticleLoad={onArticleLoad} />;
    $[5] = articleType;
    $[6] = country;
    $[7] = limit;
    $[8] = seoLevel;
    $[9] = theme;
    $[10] = topic;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t3 || $[13] !== t4) {
    t5 = <div className="grid gap-comfy-xl md:gap-roomy-sm">{t3}{t4}</div>;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
};